import React, {useMemo, useState} from 'react';
import {IDeviceActivityTransform, StatusDeviceActivity} from "@containers/device/containers/deviceActivity/types";
import TableCustom from "@ui/tableCustom/TableCustom";
import HeadSidebar from "./headSidebar/HeadSidebar";
import {useQueryParams} from "@hooks/query/useQueryParams";
import {useExportParams} from "@containers/export/containers/buildData/hooks/useExportParams";
import {useTranslateArray} from "@labels/hooks/useTranslateArray";
import {FULL_COLUMNS} from "./constants/index";
import {MapperRowCbType} from "@ui/tableCustom/types/table";
import Item from "./item/Item";
import {useTransformData} from "./hooks/useTransformData";
import {
    useGetDeviceActivityQuery
} from "@containers/device/containers/deviceActivity/fetchingData/useDeviceActivityQuery";

interface IProps {
    initialStatus?: StatusDeviceActivity
}


const ListDeviceActivity = ({
                                initialStatus,
                            }: IProps) => {

    const [targetStatus, setTargetStatus] = useState<StatusDeviceActivity | '0'>(initialStatus ?? '0')
    const [targetGroupIds, setTargetGroupIds] = useState<string[]>([])

    const {
        data,
        isLoading,
        isFetching,
        refetch
    } = useGetDeviceActivityQuery()

    const fullColumns = useTranslateArray({array: FULL_COLUMNS})

    const currentColumns = useMemo(() => {
        if (!data?.hasAppVersion) {
            return fullColumns?.filter((col) => col.id !== 'appVersion')
        }
        return fullColumns
    }, [fullColumns, data])

    const params = useQueryParams({
        initialOrder: 'lastEventTimeTimestamp',
        initialDirection: 'DESC'
    })

    const exportParams = useExportParams<IDeviceActivityTransform>({
        initialExportDataFromAllPage: true,
    })

    const {transformData} = useTransformData({data: data?.devices})

    const dataWidthStatus = useMemo(() => {
        if ((!targetStatus || targetStatus === '0') && !targetGroupIds?.length) {
            return transformData
        }
        let arr = transformData;
        if (targetStatus && targetStatus !== '0') {
            arr = transformData?.filter((item) => item.status === targetStatus)
        }
        if (targetGroupIds?.length) {
            arr = arr?.filter((item) => item.groupNames?.some((it) => targetGroupIds.includes(it)))
        }
        return arr;
    }, [transformData, targetStatus, targetGroupIds])

    const mapperRowCb: MapperRowCbType<IDeviceActivityTransform> = React.useCallback(({
                                                                                          content,
                                                                                          exportFeaturesProps
                                                                                      }) => {
        return (
            <Item
                key={content?.id}
                content={content}
                exportFeaturesProps={exportFeaturesProps}
                columns={currentColumns}
            />
        )
    }, [dataWidthStatus,currentColumns])

    return (
        <TableCustom
            <IDeviceActivityTransform>
            isLoading={isLoading || isFetching}
            fullColumns={currentColumns}
            mapperRowCb={mapperRowCb}
            exportParams={exportParams}
            params={params}
            data={dataWidthStatus}
            hasLocalFilters
            headSideBar={<HeadSidebar
                params={params}
                targetStatus={targetStatus}
                setTargetStatus={setTargetStatus}
                targetGroupIds={targetGroupIds}
                setTargetGroupIds={setTargetGroupIds}
                groups={data?.groups}
                onRefetch={refetch}
            />}
        />
    );
};

export default ListDeviceActivity;